// Homepage
import { homeRoutes } from './home.router'
import { aboutUsRoutes } from './about-us.router'
import { certificationRoutes } from './certification.router'
import { assessorRoutes } from './assessor.router'
import { tukRoutes } from './tuk.router'
import { galleryRoutes } from './gallery.router'
import { contactUsRoutes } from './contact-us.router'
import { newsRoutes } from './news.router'

const webpageRoutes = [
  ...homeRoutes,
  ...aboutUsRoutes,
  ...certificationRoutes,
  ...assessorRoutes,
  ...tukRoutes,
  ...galleryRoutes,
  ...contactUsRoutes,
  ...newsRoutes,
]

export { webpageRoutes }
